import { Circle, Tooltip } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'

import { ChangeType } from '@/modules/releaseNotes/domain/models/enums/ChangeType'
import AddIcon from '@/ui/assets/AddIcon'
import HammerIcon from '@/ui/assets/HammerIcon'
import LampIcon from '@/ui/assets/LampIcon'
import NewTrashDeleteIcon from '@/ui/assets/NewTrashDeleteIcon'

const primaryColor: Record<ChangeType, string> = {
  REMOVED: '#D5474C',
  ENHANCED: '#077FDE',
  FIXED: '#DF8620',
  ADDED: '#2BBB6E'
}

const secondaryColor: Record<ChangeType, string> = {
  REMOVED: '#FFD9DB',
  ENHANCED: '#E9F5FF',
  FIXED: '#FFEDD9',
  ADDED: '#D9FFEB'
}

const icon: Record<ChangeType, JSX.Element> = {
  REMOVED: <NewTrashDeleteIcon color={primaryColor['REMOVED']} />,
  ENHANCED: <LampIcon color={primaryColor['ENHANCED']} />,
  FIXED: <HammerIcon color={primaryColor['FIXED']} />,
  ADDED: <AddIcon color={primaryColor['ADDED']} />
}

export default function FeatureChangeIcon({
  changeType
}: {
  changeType: ChangeType
}) {
  const { t } = useTranslation()

  return (
    <Tooltip
      label={t(
        `releaseNotes.changeType.${
          changeType.toLowerCase() as Lowercase<typeof changeType>
        }`
      )}
      aria-label={t(
        `releaseNotes.changeType.${
          changeType.toLowerCase() as Lowercase<typeof changeType>
        }`
      )}
    >
      <Circle bg={secondaryColor[changeType]} size={'24px'}>
        {icon[changeType]}
      </Circle>
    </Tooltip>
  )
}
